const AppBusinessKey: any = {
  dev: {
    'LNK-CLINICAL-4786': 'Hospital Quality',
    'LNK-ENTERPRI-4759': 'Physician Review',
    'LNK-HOSPITAL-5012': 'Hospital Utilization',
    'LNK-SPOTLIGH-5056': 'Spotlight',
    'LNK-ADVANCED-5235': 'Advanced Reporting',
    'LNK-SURGICAL-5844': 'Surgical Cost',
    'LNK-SURGICAL-7039': 'Surgical Capacity',
    'LNK-USERMANA-5957': 'Settings',
    'LNK-AMBULATO-7452': 'Ambulatory Quality',
    'LNK-STARRATI-7571': 'Star Rating',
  },
  integration: {
    'LNK-HOSPITAL-5059': 'Hospital Quality',
    'LNK-PHYSICIA-5058': 'Physician Review',
    'LNK-HOSPITAL-5060': 'Hospital Utilization',
    'LNK-SPOTLIGH-5057': 'Spotlight',
    'LNK-ADVANCED-5236': 'Advanced Reporting',
    'LNK-SURGICAL-5845': 'Surgical Cost',
    'LNK-USERMANA-5950': 'Settings',
    'LNK-SURGICAL-7038': 'Surgical Capacity',
    'LNK-AMBULATO-7453': 'Ambulatory Quality',
    'LNK-STARRATI-7572': 'Star Rating',
  },
  stage: {
    'LNK-HOSPITAL-565': 'Hospital Quality',
    'LNK-HOSPITAL-562': 'Hospital Utilization',
    'LNK-PHYSICIA-568': 'Physician Review',
    'LNK-SPOTLIGH-559': 'Spotlight',
    'LNK-ADVANCED-580': 'Advanced Reporting',
    'LNK-SURGICAL-732': 'Surgical Cost',
    'LNK-USERMANA-644': 'Settings',
    'LNK-SURGICAL-738': 'Surgical Capacity',
    '<STAR_RATING_BUSINESS_KEY_PLACEHOLDER>': 'Star Rating',
  },
  'stage-previous-version': {
    'LNK-HOSPITAL-565': 'Hospital Quality',
    'LNK-HOSPITAL-562': 'Hospital Utilization',
    'LNK-PHYSICIA-568': 'Physician Review',
    'LNK-SPOTLIGH-559': 'Spotlight',
    'LNK-ADVANCED-580': 'Advanced Reporting',
    'LNK-USERMANA-644': 'Settings',
    'LNK-SURGICAL-738': 'Surgical Capacity',
    '<STAR_RATING_BUSINESS_KEY_PLACEHOLDER>': 'Star Rating',
  },
  uat: {
    'LNK-HOSPITAL-566': 'Hospital Quality',
    'LNK-HOSPITAL-563': 'Hospital Utilization',
    'LNK-PHYSICIA-569': 'Physician Review',
    'LNK-SPOTLIGH-560': 'Spotlight',
    'LNK-ADVANCED-581': 'Advanced Reporting',
    'LNK-SURGICAL-731': 'Surgical Cost',
    'LNK-USERMANA-645': 'Settings',
    'LNK-SURGICAL-737': 'Surgical Capacity',
    '<STAR_RATING_BUSINESS_KEY_PLACEHOLDER>': 'Star Rating',
  },
  production: {
    'LNK-HOSPITAL-567': 'Hospital Quality',
    'LNK-HOSPITAL-564': 'Hospital Utilization',
    'LNK-PHYSICIA-570': 'Physician Review',
    'LNK-SPOTLIGH-561': 'Spotlight',
    'LNK-ADVANCED-579': 'Advanced Reporting',
    'LNK-SURGICAL-730': 'Surgical Cost',
    'LNK-USERMANA-646': 'Settings',
    'LNK-SURGICAL-734': 'Surgical Capacity',
    '<STAR_RATING_BUSINESS_KEY_PLACEHOLDER>': 'Star Rating',
  },
};

export default AppBusinessKey;
